var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.markup
    ? _c("div", { staticClass: "ad", class: "ad--" + _vm.size }, [
        _vm.isOn(_vm.showLabel)
          ? _c("span", { staticClass: "ad__label" }, [
              _vm._v(_vm._s(_vm.label)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "ad__code",
          domProps: { innerHTML: _vm._s(_vm.markup) },
        }),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }